var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFintech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 10.3496C0.664062 4.82676 5.14121 0.349609 10.6641 0.349609H38.6641C44.1869 0.349609 48.6641 4.82676 48.6641 10.3496V38.3496C48.6641 43.8725 44.1869 48.3496 38.6641 48.3496H10.6641C5.14121 48.3496 0.664062 43.8725 0.664062 38.3496V10.3496Z",
    fill: "url(#paint0_linear_4168_5850)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6641 34.3496V16.3496C18.6641 15.8192 18.8748 15.3105 19.2498 14.9354C19.6249 14.5603 20.1336 14.3496 20.6641 14.3496H28.6641C29.1945 14.3496 29.7032 14.5603 30.0783 14.9354C30.4533 15.3105 30.6641 15.8192 30.6641 16.3496V34.3496H18.6641Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6641 24.3496H16.6641C16.1336 24.3496 15.6249 24.5603 15.2498 24.9354C14.8748 25.3105 14.6641 25.8192 14.6641 26.3496V32.3496C14.6641 32.88 14.8748 33.3887 15.2498 33.7638C15.6249 34.1389 16.1336 34.3496 16.6641 34.3496H18.6641",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6641 21.3496H32.6641C33.1945 21.3496 33.7032 21.5603 34.0783 21.9354C34.4533 22.3105 34.6641 22.8192 34.6641 23.3496V32.3496C34.6641 32.88 34.4533 33.3887 34.0783 33.7638C33.7032 34.1389 33.1945 34.3496 32.6641 34.3496H30.6641",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6641 18.3496H26.6641",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6641 22.3496H26.6641",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6641 26.3496H26.6641",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6641 30.3496H26.6641",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5850",
    x1: 24.6641,
    y1: 0.349609,
    x2: 24.6641,
    y2: 48.3496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintech);
export default __webpack_public_path__ + "static/media/Fintech.70b996d72b152dfdb1c22de1cb91282e.svg";
export { ForwardRef as ReactComponent };